import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receipt-ticket-ballot',
  templateUrl: './receipt-ticket-ballot.component.html',
  styleUrls: ['./receipt-ticket-ballot.component.scss']
})
export class ReceiptTicketBallotComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
